/**
 * Hide Emergent-scoped UI when the app is served from a non-emergent domain
 * (e.g. innercompass.tech). On *.emergent.host or
 * *.preview.emergentagent.com the badge stays visible.
 *
 * This runs once, immediately on page load, from index.js.
 */
(function hideEmergentOnCustomDomain() {
  try {
    if (typeof window === "undefined") return;
    const host = window.location.hostname || "";
    const isEmergentHost =
      /(^|\.)emergent\.host$/i.test(host) ||
      /(^|\.)emergentagent\.com$/i.test(host) ||
      host === "localhost" ||
      host === "127.0.0.1";
    if (isEmergentHost) return;

    // Hide the "Made with Emergent" badge if it exists.
    const badge = document.getElementById("emergent-badge");
    if (badge && badge.parentNode) {
      badge.parentNode.removeChild(badge);
    }
    // Belt-and-suspenders: hide via style tag too, in case the script above
    // races the badge's own script that re-injects it.
    const style = document.createElement("style");
    style.setAttribute("data-emergent-hide", "true");
    style.textContent = "#emergent-badge{display:none !important;visibility:hidden !important;}";
    document.head.appendChild(style);
  } catch {
    // no-op
  }
})();
